module.exports = __webpack_public_path__ + "16d2702dd0f0b119d5db7e05aa90dfdc.svg";